import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.BASE_URL
});

export const handleFetchUserProfile = async (username) => {
  try {
    const response = await instance.get(`/users/${username}`);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleUpdatePassword = async (userId, payload) => {
  try {
    const { data } = await instance.put(`/users/${userId}/update_password`,
      payload,
      { headers: { 'Content-Type': 'multipart/form-data' } });

    return data;
  } catch (error) {
    return error;
  }
};

export const handleUpdateUser = async (userId, formData) => {
  try {
    const { data } = await instance.put(`/users/${userId}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } });

    return data;
  } catch (error) {
    return error;
  }
};



// WEBPACK FOOTER //
// ./src/store/api/user/index.js